export default "__VITE_ASSET__U$ji9$4j__"